import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import topbatch from '../images/topbatch.png'; // adjust path if needed
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import dummyImg from '../images/no-image-thumb.jpg'
import generateSlug from './common/generateSlug';

// import './TopProjectsCarousel.css'; // Create for styles if needed

const PrevArrow = ({ onClick }) => (
  <button className="custom-btn custom-btn-prev" onClick={onClick}>
    &lt;
  </button>
);

const NextArrow = ({ onClick }) => (
  <button className="custom-btn custom-btn-next" onClick={onClick}>
    &gt;
  </button>
);

const AdvertisementTopProjects = ({ topProjects, param, prefix }) => {




  const filteredProjects = topProjects?.filter((project) =>
    prefix === 'srcid'
      ? project.city_name === param?.name
      : project.sub_locality_name === param?.name
  );


  const handleLinkClick = (project) => {
    //alert(JSON.stringify(project))
    // let url = '';
    // url = `/sell-pid-${project.project_id}`;
    const url = generateSlug(project);
    window.location.href = url;
    localStorage.setItem('last-property-seen', JSON.stringify({ id: project.project_id, typeWithId: url }))
  }
  console.log(filteredProjects)

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  return (
    <>
    {filteredProjects?.length > 0 && (
      <div className='top_project desk relative mt-5'>
        {filteredProjects?.length > 0 && (
          <img src={topbatch} className="mobtopbatch" alt="Top Projects Batch" />
        )}
        <div className="custom-carousel top_project_carousel">
          <Slider {...settings}>
            {filteredProjects?.map((project, index) => (
              <div className="custom-slide position-relative" key={index}>
                <Link onClick={() => handleLinkClick(project)}>
                  <img
                    src={project.property_image[0]?.image}
                    className="card-img-top"
                    alt={project.project_name}
                    onError={(e) => {
                      e.target.onerror = null; // prevent infinite loop
                      e.target.src = dummyImg; // fallback image path
                    }}
                  />
                  <div className="custom-overlay">
                    <h3 className='ad-slider-text'>{project.project_name}</h3>
                    <p className='avd-title-text-2'>{project.sub_locality_name}</p>
                  </div>
                </Link>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    )}
    </>
  );
};

export default AdvertisementTopProjects;
